import { axiosPrivate } from 'app/utils';
import helpers from '../helpers';

export default {
  async getPharmacyLinkRequests({ pharmacyId, page, limit, order, orderBy }) {
    const queryParams = [];
    if (typeof page === 'number') queryParams.push(`page=${page}`);
    if (typeof limit === 'number') queryParams.push(`limit=${limit}`);
    if (typeof order === 'string') queryParams.push(`order=${order}`);
    if (typeof orderBy === 'string') queryParams.push(`orderBy=${orderBy}`);
    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
    const response = await axiosPrivate.get(
      `/v3/pharmacist/pharmacies/${pharmacyId}/patient-link-requests${queryString}`,
      {}
    );
    if (response.data.error) helpers.throwError(response.data.error);
    return {
      requests:
        response.data?.requests?.map((request) => ({
          id: request.id,
          _id: request.userId,
          forename: request.patientDetails.firstName,
          surname: request.patientDetails.lastName,
          dateOfBirth: request.patientDetails.dateOfBirth,
          telephone: request.patientDetails.telephone,
          email: request.patientDetails.email,
          requestedDate: request.createdAt,
          requestId: request.id,
          pharmacyId: request.pharmacyId,
          address: request.patientDetails.address,
        })) || [],
      pagination: {
        ...response.data?.pagination,
        current_page: response.data?.pagination?.currentPage,
      },
    };
  },
  async getPharmacyLinkRequestById({ pharmacyId, requestId }) {
    const response = await axiosPrivate.get(
      `/v3/pharmacist/pharmacies/${pharmacyId}/patient-link-requests/${requestId}`,
      {}
    );
    if (response.data.error) helpers.throwError(response.data.error);

    return {
      linkRequest: response.data?.linkRequest,
    };
  },
  async updatePharmacyLinkRequestStatus({ pharmacyId, requestId, status }) {
    const response = await axiosPrivate.put(
      `/v3/pharmacist/pharmacies/${pharmacyId}/patient-link-requests/${requestId}/status`,
      {
        status,
      }
    );
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },
};
